import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaTiktok,
  FaTwitter,
  FaLinkedin,
} from "react-icons/fa";

import appStoreBadge from "../assets/appstore.webp";
import googlePlayBadge from "../assets/googleplay.webp";
import NewsletterSignup from "./NewsLetterSignup";

const SOCIALS = [
  {
    href: "https://www.facebook.com/zorqk",
    icon: <FaFacebookF />,
    label: "Facebook",
    color: "#1877F2",
  },
  {
    href: "https://www.instagram.com/zorqk.cars",
    icon: <FaInstagram />,
    label: "Instagram",
    color: "#E4405F",
  },
  {
    href: "https://www.linkedin.com/company/zorqk",
    icon: <FaLinkedin />,
    label: "LinkedIn",
    color: "#0A66C2",
  },
  {
    href: "https://www.tiktok.com/@zorqk.cars",
    icon: <FaTiktok />,
    label: "TikTok",
    color: "#25F4EE",
  },
  {
    href: "https://www.youtube.com/@ZORQK",
    icon: <FaYoutube />,
    label: "YouTube",
    color: "#FF0000",
  },
];

export default function Footer() {
  return (
    <footer className="relative w-full bg-accent text-white pt-16 mt-60 z-50">
      {/* Top email subscription section */}
      <NewsletterSignup />

      {/* Help and app links */}
      <div className="text-center">
        <p className="max-w-5xl mx-auto px-4 text-justify md:text-center my-0 md:my-5 text-sm md:text-base leading-relaxed font-medium text-gray-200">
          ZORQK.COM LIMITED is an Introducer Appointed Representative of Percy
          Finance Ltd, which is authorised and regulated by the Financial
          Conduct Authority (FCA). Percy Finance Ltd FRN: 1005021.
        </p>
        <p className="max-w-5xl mx-auto px-4 text-justify md:text-center my-0 md:my-5 text-sm md:text-base leading-relaxed font-medium text-gray-200">
          ZORQK.COM LIMITED is not authorised by the FCA and does not provide
          regulated advice or arrange regulated finance or insurance. ZORQK.COM
          LIMITED only introduces customers to Percy Finance Ltd for these
          products.
        </p>
        <p className="max-w-5xl mx-auto px-4 text-justify md:text-center my-0 md:my-5 text-sm md:text-base leading-relaxed font-medium text-gray-200">
          You can check our status on the Financial Services Register.
        </p>

        <p className="text-base md:text-lg lg:text-xl mt-16 mb-5 font-medium">
          <Link to="/contact-us">Help and support →</Link>
        </p>
        {/* <div className="flex justify-center space-x-2 md:space-x-4">
          <img src={appStoreBadge} alt="App Store" className="h-12" />
          <img src={googlePlayBadge} alt="Google Play" className="h-12" />
        </div> */}
      </div>

      {/* Footer links */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-center mt-12 max-w-5xl mx-auto px-4">
        <div className="flex flex-col gap-3 space-y-2 font-bold">
          {/* <Link to="/">Home</Link> */}
          {/* <Link to="/">Find a car</Link> */}
          {/* <Link to="/">How ZORQK works</Link> */}
          {/* <Link to="/">FAQs</Link> */}
          {/* <Link to="/">Careers</Link> */}
          <Link to="/used-cars">Used cars</Link>
          <Link to="/about-us">About us</Link>
          <Link to="/contact-us">Contact Us</Link>
        </div>
        <div className="flex flex-col gap-3 space-y-2 font-bold">
          {/* <Link to="/">Careers</Link> */}
          <Link to="/delivery">Delivery</Link>
          {/* <Link to="/">Collections</Link> */}
          <Link to="/which-car-should-i-buy">Which car should I buy</Link>
          {/* <Link to="/contact-us">Support</Link> */}
        </div>
        <div className="flex flex-col gap-3 space-y-2 font-bold">
          <Link to="/policies/terms-of-use">Terms of use</Link>
          <Link to="/policies/privacy">Privacy policy</Link>
          <Link to="/policies/cookie-policy">Cookie policy</Link>
          {/* <Link to="">Gender pay gap</Link>
          <Link to="/policies/modern-slavery-statement">Modern slavery</Link> */}
        </div>
      </div>

      {/* Social icons */}
      <div className="mt-12 pb-7 flex justify-center space-x-6 text-white text-2xl">
        {SOCIALS.map(({ href, icon, label, color }) => (
          <Link
            key={href}
            to={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className={`
          transition transform hover:scale-110 hover:text-[${color}] 
          hover:shadow-md p-1 rounded focus:outline-none focus:ring-2 
          focus:ring-offset-2 focus:ring-[${color}]
        `}
          >
            {icon}
          </Link>
        ))}
      </div>
    </footer>
  );
}
